import { render, staticRenderFns } from "./LayoutPropertyDetails.vue?vue&type=template&id=7a977eed&scoped=true&"
import script from "./LayoutPropertyDetails.vue?vue&type=script&lang=js&"
export * from "./LayoutPropertyDetails.vue?vue&type=script&lang=js&"
import style0 from "./LayoutPropertyDetails.vue?vue&type=style&index=0&id=7a977eed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a977eed",
  null
  
)

export default component.exports